class OwnersvoiceController {
    constructor() {

        this.setFilter();
        this.setFilterClear();
    }

    setFilter() {
        let $btn = $('.js-ownersvoice-content__filter-head');
        $btn.on('click', function(){
            let $this = $(this);
            $this.toggleClass('is-open');
            $this.next('.js-js-ownersvoice-content__filter-body').slideToggle(160);
        });
    }

    setFilterClear() {
        let $btn = $('#js-filter-clear');
        $btn.on('click', function (e) {
            e.preventDefault();
            let $form = $('#js-ownersvoice-content__filter-form');
            $form.find('input[type="checkbox"]').each(function () {
                let $this = $(this);
                $this.prop('checked', false);
            });
        });
    }
}

export default OwnersvoiceController;